import { Grid, Paper, Tooltip, Typography } from "@mui/material"
import { format } from "date-fns"
import React from "react"
import { CancelCharge } from "../../Objects/CancelCharge"

export interface CancelChargeCardProps {
    cancelCharge: CancelCharge
}
const CancelChargeCard: React.FC<CancelChargeCardProps> = ({
    cancelCharge
}) => {
    return (
        <Paper
            variant="outlined"
            sx={cancelCharge.is_settled ? {
                p: 2,
                backgroundColor: '#eee'
            } : {
                p: 2
            }}
        >
            <Grid container>
                <Grid item xs={12} sm={6}>
                    <Typography>
                        [{cancelCharge.code ? cancelCharge.code : cancelCharge.ctm_id}] {(cancelCharge.ctm_name1 || cancelCharge.ctm_name2) ? `${cancelCharge.ctm_name1} ${cancelCharge.ctm_name2}` : `${cancelCharge.ctm_pronunciation1} ${cancelCharge.ctm_pronunciation2}`}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Tooltip title={
                        <Grid container>
                            {cancelCharge.reserve_reg_date &&
                                <>
                                    <Grid item xs={12}>
                                        <Typography variant="body2">予約登録日/登録者</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" textAlign="right">{format(cancelCharge.reserve_reg_date, "yyyy/MM/dd HH:mm:ss")} / {cancelCharge.reg_staff_name ? cancelCharge.reg_staff_name : "online"}</Typography>
                                    </Grid>
                                </>
                            }
                            {cancelCharge.reserve_edit_date &&
                                <>
                                    <Grid item xs={12}>
                                        <Typography variant="body2">予約編集日/登録者</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" textAlign="right">{format(cancelCharge.reserve_edit_date, "yyyy/MM/dd HH:mm:ss")} / {cancelCharge.edit_staff_name}</Typography>
                                    </Grid>
                                </>
                            }
                            <Grid item xs={12}>
                                <Typography variant="body2">キャンセル登録日/登録者</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body2" textAlign="right">{format(cancelCharge.cancel_reg_date, "yyyy/MM/dd HH:mm:ss")} / {cancelCharge.cancel_staff_name ? cancelCharge.cancel_staff_name : "-"}</Typography>
                            </Grid>
                        </Grid>
                    }>
                        <Typography
                            textAlign="right"
                            variant="body2"
                        >{format(cancelCharge.cancel_reg_date, "yyyy年MM月dd日 HH時mm分ss秒")}</Typography>
                    </Tooltip>

                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2">{cancelCharge.comment}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography textAlign="right">{cancelCharge.charge.toLocaleString()}円{cancelCharge.is_settled && '  (支払済)'}</Typography>
                </Grid>
            </Grid>
        </Paper>
    )
}

export default CancelChargeCard